import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './components/App'
import './index.css'
import './types'
import {HashRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import AppErrorBoundary from './components/AppErrorBoundary'
import {store} from './store/store'

const container = document.getElementById('appRoot')
const root = createRoot(container!)
root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </AppErrorBoundary>
)
